export class RequestProductPasswordForm {
  constructor() {
    this.customerProducts = {};
    this.selectedProducts = {};
    this.transactionPassword = null;
    this.memberProductId = null;
    this.isViewed = false;

    this.isUsingGoogleTwoFactor = false;

    this.props = {
      isSubmitting: false,
      isReady: false,
      readOnly: false
    };

    this.successMessage = {
      title: 'Success',
      body: 'Product password successfully requested.',
    };
  }

  get isReadOnly() {
    return this.props.readOnly;
  }

  reset() {
    this.selectedProducts = {};
    this.transactionPassword = null;
  }

  authenticationSwitched(isUsingGoogleTwoFactor) {
    this.isUsingGoogleTwoFactor = isUsingGoogleTwoFactor;
  }

  toPayload() {
    let payload = {
      memberProductRequestPassword: {
        memberProducts: {},
        transactionPassword: this.transactionPassword,
        usingGoogleAuthPassword: this.isUsingGoogleTwoFactor,
      }
    };

    let index = 0;
    angular.forEach(this.selectedProducts, (selectedProduct, id) => {
      if (selectedProduct.isSelected) {
        payload.memberProductRequestPassword.memberProducts[index] = {
          memberProductId: parseInt(id),
        };
        index ++;
      }
    });

    return payload;
  }

  toViewPayload() {
    let payload = {
      memberProductField: {
        memberProductId: this.memberProductId
      }
    };

    return payload;
  }
}

export default RequestProductPasswordForm;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/product-password-widget/model/form.model.js